App = App || {};

App.BalanceAdjustOffcanvas = (function ($, Vue) {
	"use strict";

	var $modal, viewModel;

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("balance-adjustment-app");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		viewModel = new Vue({
			el: rootElement,
			data: {
				memberProfile: {
					id: $modal.data("id") || 0,
					pointBalance: ''
				},
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: [],
				balanceAdjustment: {
					id: $modal.data("id") || 0,
					amount: null,
					reason: ""
				}
			},
			methods: {
				setMemberId: function (id) {
					this.balanceAdjustment.id = String(id ?? '');
				},

				validateAmount: function () {
					var el = this.$el.querySelector("#adj-amount");
					if (el && el.setCustomValidity)
						el.setCustomValidity(Number.isInteger(this.balanceAdjustment.amount) && this.balanceAdjustment.amount !== 0 ? "" : "Invalid");
				},

				reset: function () {
					this.isSubmitting = false;
					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];
					this.balanceAdjustment.id = $modal.data("id") || 0;
					this.balanceAdjustment.amount = null;
					this.balanceAdjustment.reason = "";
					this.$refs.form.classList.remove("was-validated");
					this.validateAmount();
				},

				close: function () {
					$modal.modal("hide");
				},

				loadProfile: function () {
					var id = $modal.data("id");

					return $.ajax({
						url: `/api/members/${id}`,
						method: "GET",
						dataType: "json"
					})
						.done(response => {
							if (!response || !response.success || !response.data) {
								this.alertMessage = (response && response.message) || "Failed loading profile.";
								return;
							}

							this.memberProfile = response.data;
							this.memberProfile.customDealer = this.memberProfile.customDealer || { name: "", address: "" };
						})
						.fail((jqXHR, status, err) => {
							console.error("AJAX error loading profile:", status, err);
							this.alertMessage = "Failed loading profile.";
						});
				},

				submit: function () {
					this.validateAmount();
					if (!this.$refs.form.checkValidity()) {
						this.$refs.form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;

					$.ajax({
						url: "/api/members/adjust-balance",
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify(this.balanceAdjustment),
						timeout: 10000,
						headers: { "Accept": "application/json" }
					})
					.done(response => {
						if (response && response.success) {
							this.isComplete = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (response && response.message) || "Adjustment failed.";

							this.alertErrors = ((response && response.data && response.data.errors) || [])
								.map(e => e.description || e).filter(Boolean);

							this.$refs.form.classList.add("was-validated");
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					})
					.fail((jq, status, err) => {
						if (status !== "abort") {
							console.error("AJAX error posting adjustment:", status, err);
							this.alertMessage = jq.status === 404
								? "Endpoint not found (404)."
								: (status === "timeout" ? "Request timed out." : "Adjustment failed.");
							this.$refs.form.classList.add("was-validated");
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					})
					.always(() => { this.isSubmitting = false; });
				}
			},
			mounted: function () {
				$modal.off('show.bs.modal hidden.bs.modal');

				$modal.on('show.bs.modal', (event) => {
					this.reset();
					this.loadProfile()
						.always(() => {
							this.isLoading = false;
						});
				});
			}
		});
	}

	function open(id, onClose)  {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return { init, open };
})(jQuery, Vue);

App.BalanceAdjustOffcanvas.init();